import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sumValues'
})
export class SumValuesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return Number((Number(value) + Number(args)).toFixed(6));
  }

}



// WEBPACK FOOTER //
// ./src/app/custompipes/sum-values.pipe.ts